// extracted by mini-css-extract-plugin
export var active = "_2r-9";
export var backButton = "_2r-8";
export var clone = "_2r-e";
export var collapseBar = "_2r-k";
export var collapseMode = "_2r-m";
export var collapsed = "_2r-o";
export var dimmed = "_2r-i";
export var dragHandle = "_2r-c";
export var dropdownIcon = "_2r-g";
export var expanding = "_2r-n";
export var hidden = "_2r-x";
export var iconContainer = "_2r-q";
export var iconSwapper = "_2r-w";
export var navItem = "_2r-6";
export var navItemIcon = "_2r-f";
export var navProfile = "_2r-7";
export var notificationCountBadge = "_2r-j";
export var notificationDot = "_2r-r";
export var optionsContainer = "_2r-h";
export var primaryNav = "_2r-0";
export var primaryNavDivider = "_2r-v";
export var primaryNavResizeHandle = "_2r-2";
export var primaryNavResizing = "_2r-1";
export var primaryNavTabSection = "_2r-u";
export var primaryTab = "_2r-p";
export var primaryTabIconBox = "_2r-s";
export var secondaryNav = "_2r-3";
export var selected = "_2r-t";
export var settingsNav = "_2r-4";
export var settingsNavItems = "_2r-5";
export var show = "_2r-d";
export var sideNav = "_2r-l";
export var teamItem = "_2r-a";
export var userProfileItem = "_2r-b";